/* Pack picker behaviour.
   Lives in its own file because the quick-view modal injects the picker markup
   with innerHTML, and script tags inserted that way never execute - so the copy
   of this logic that used to sit inside the snippet did nothing in the modal.
   Everything here is delegated from document, so it works for markup that
   appears later, and every lookup is scoped to the picker's own product context
   so a modal cannot disturb the picker on the page behind it. */
(function () {
  if (window.__smPackPicker) return;
  window.__smPackPicker = true;

  function contextFor(el) {
    return el.closest('.quick-product, .product, main, body') || document;
  }

  function selectedRadio(root) {
    return root.querySelector('input[name="pack_variant_id"]:checked');
  }

  function paintSelection(radio) {
    var group = radio.closest('.pack-product-variants');
    if (!group) return;
    var card = radio.closest('.pack-variant-card');
    group.querySelectorAll('.pack-variant-card').forEach(function (c) {
      c.classList.remove('is-selected');
    });
    if (card) card.classList.add('is-selected');
  }

  function paintPrice(radio, ctx) {
    var card = radio.closest('.pack-variant-card');
    if (!card) return;
    var priceEl = card.querySelector('.pack-price');
    var compareEl = card.querySelector('.pack-compare');
    if (!priceEl) return;
    var price = priceEl.textContent.trim();
    var compare = compareEl ? compareEl.textContent.trim() : '';
    var html = compare
      ? 'MRP: <span style="text-decoration:line-through;color:#777;">' + compare + '</span> <span style="color:#e11b22;">' + price + '</span>'
      : 'MRP: <span style="color:#e11b22;">' + price + '</span>';
    ctx.querySelectorAll('.product__price, [data-price], .product-price').forEach(function (el) {
      el.innerHTML = html;
    });
  }

  function paintImage(radio, ctx) {
    var mediaId = radio.getAttribute('data-media-id');
    var mediaSrc = radio.getAttribute('data-media-src');
    if (!mediaId) return;
    var matched = false;
    ctx.querySelectorAll('[data-product-media-wrapper]').forEach(function (wrap) {
      var isMatch = wrap.getAttribute('data-media-item-id') === mediaId;
      wrap.classList.toggle('hidden', !isMatch);
      if (isMatch) matched = true;
    });
    if (!matched && mediaSrc) {
      var img = ctx.querySelector('.product__media:not(.hidden) img, .product__media-container img');
      if (img) {
        img.src = mediaSrc;
        img.srcset = '';
      }
    }
  }

  function syncForms(radio, ctx) {
    ctx.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        form.appendChild(input);
      }
      input.value = radio.value;
      input.setAttribute('value', radio.value);
    });
  }

  function apply(radio) {
    if (!radio) return;
    var ctx = contextFor(radio);
    paintSelection(radio);
    paintPrice(radio, ctx);
    paintImage(radio, ctx);
    syncForms(radio, ctx);
  }

  document.addEventListener('change', function (e) {
    var radio = e.target.closest ? e.target.closest('input[name="pack_variant_id"]') : null;
    if (radio) apply(radio);
  });

  /* keep the form honest even if something submits without firing change */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (!e.target.closest('button[type="submit"], [name="add"], .product-form__cart-submit')) return;
    var ctx = contextFor(e.target);
    var radio = selectedRadio(ctx);
    if (radio) syncForms(radio, ctx);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var ctx = contextFor(form);
    var radio = selectedRadio(ctx);
    if (radio) syncForms(radio, ctx);
  }, true);

  function initAll(scope) {
    (scope || document).querySelectorAll('.pack-product-variants').forEach(function (group) {
      var radio = selectedRadio(group) || group.querySelector('input[name="pack_variant_id"]');
      if (radio) {
        radio.checked = true;
        apply(radio);
      }
    });
  }

  /* the quick-view modal builds its markup after load, so watch for it */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.pack-product-variants')) { initAll(node.parentNode); return; }
        if (node.querySelector && node.querySelector('.pack-product-variants')) { initAll(node); return; }
      }
    }
  });

  function start() {
    initAll(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
